import { RouteRecordRaw } from 'vue-router'

import Home from './Home.vue'

const createNewAccountRoutes: Array<RouteRecordRaw> = [
  {
    path: '/create-account/create-new-password',
    name: 'createNewPassword',
    component: Home,
  },
  {
    path: '/create-account/confirm-password',
    name: 'confirmPassword',
    component: Home,
  },
]

export default createNewAccountRoutes
